<template>
   <div>
    <div class="page-header">
          <div class="row justify-content-end">
            <div class="col-10 text-left">
              <h2 class="page-title" v-if="currentEduType == 'Diploma' || currentEduType == 'SSC' || currentEduType == 'HSC'">{{currentEduType}} {{$t('candidateProfile.qualificationDetails.lblDetails')}}</h2>
              <h2 class="page-title" v-if="currentEduType == 'HSCHallTicket'">{{$t('candidateProfile.qualificationDetails.lblHSCHallTicketDetails')}} {{$t('candidateProfile.qualificationDetails.lblDetails')}}</h2>
              <h2 class="page-title" v-if="currentEduType == 'DiplomaHallTicket'">{{$t('candidateProfile.qualificationDetails.lblDiplomaHallTicketDetails')}} {{$t('candidateProfile.qualificationDetails.lblDetails')}}</h2>
            </div>
            <div class="col-2 lighten text-right">
              <h2 class="page-title">80%</h2>
            </div>
          </div>
        </div>
      <form class="row justify-content-center p-details" action="POST" v-on:submit.prevent="save('form-1')" data-vv-scope="form-1">
              
        <div class="col-12">
                  <div class="row">
          <div class="col-10 pt-3">
          <div class="para alert alert-success"> <strong>{{$t('candidateProfile.qualificationDetails.lblNote')}}</strong> <span v-if="currentEduType == 'Diploma' || currentEduType == 'SSC' || currentEduType == 'HSC'">{{$t('candidateProfile.qualificationDetails.noteMarksheet')}}</span><span v-if="currentEduType == 'HSCHallTicket'">{{$t('candidateProfile.qualificationDetails.noteHSCHallticket')}}</span><span v-if="currentEduType == 'DiplomaHallTicket'">{{$t('candidateProfile.qualificationDetails.noteDiplomaHallticket')}}</span> </div>
          </div>
          <div class="col-2 text-center">
        <img :src="marksheetUrl" class="dpics documentImg img-fluid img-thumbnail ml-2"  @click="showModal = true" ></img>
                  <span class="pcss input-group-addon" :title="$t('candidateProfile.qualificationDetails.tooltipViewDoc')">
        <div class="title para green-note text-center "><i> <span v-if="currentEduType == 'Diploma' || currentEduType == 'SSC' || currentEduType == 'HSC'">{{currentEduType}} {{$t('candidateProfile.qualificationDetails.lblMarksheet')}}</span><span v-if="currentEduType == 'HSCHallTicket'">{{$t('candidateProfile.qualificationDetails.lblHSCHallTicketDetails')}}</span><span v-if="currentEduType == 'DiplomaHallTicket'">{{$t('candidateProfile.qualificationDetails.lblDiplomaHallTicketDetails')}}</span> </i></div>
        </span>
</div>
        </div>

          <div class="form-group custom-input pb-5 pt-0" v-if="(currentEduType === 'SSC' || currentEduType == 'HSC' || currentEduType == 'Diploma')">
                  <div class="para">{{$t('candidateProfile.qualificationDetails.lblIHaveCompleted')}} {{currentEduType}} {{$t('candidateProfile.qualificationDetails.lblFrom')}}</div> 
                  <v-select label="boardName" :class="{'form-error': errors.has('board')}" v-model="selectedBoard" :options="boardList" :error-messages="errors.collect('board')" v-validate="'required|not_in:Select'" data-vv-name="board" name="board" :placeholder="$t('candidateProfile.qualificationDetails.plceHoSelectBoard')" required></v-select>
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
                  <div class="para"> {{$t('candidateProfile.qualificationDetails.lblDateOfExam')}}
                    <date-picker name="dateofResult" v-model="startTime" v-validate="'required|not_in:Select'" :class="{'form-error': errors.has('dateofResult'),'input': true, 'is-danger': errors.collect('dateofResult') }" data-vv-name="dateofResult" data-vv-validate-on="change" lang="en"></date-picker>   
                  </div>
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
                  <div class="para">{{$t('candidateProfile.qualificationDetails.lblRollSeatNo')}} </div>
                  <input name="Seat No" class="form-control-alt col-3 uppercase" id="namelc" maxlength="18" oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;" v-model="educationDetails.seatNumber" v-validate="'required|regex:^([A-Za-z0-9-_]+)$'" :class="{'form-error': errors.has('form-1.Seat No'),'input': true, 'is-danger': errors.has('form-1.Seat No') }" type="text" :placeholder="$t('candidateProfile.qualificationDetails.plceHoRollSeatNo')" >
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
                  <div class="para">{{$t('candidateProfile.qualificationDetails.lblMarksheetNo')}} </div>
                  <input name="Marksheet No" class="form-control-alt col-3 uppercase" id="panNo" maxlength="18" oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;" v-validate="'required|regex:^([A-Za-z0-9-_]+)$'" v-model="educationDetails.marksheetNo" :class="{'form-error': errors.has('form-1.Marksheet No'),'input': true, 'is-danger': errors.has('form-1.Marksheet No') }" type="text" :placeholder="$t('candidateProfile.qualificationDetails.plceHoMarksheetNo')" >
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
                  <div class="para">{{$t('candidateProfile.qualificationDetails.lblWith')}} </div>
                  <input name="Total Mark" class="form-control-alt col-3 uppercase" id="totalMark" v-model="educationDetails.totalMarksObtained" v-validate="'required|numeric'" :class="{'form-error': errors.has('form-1.Total Mark'),'input': true, 'is-danger': errors.has('form-1.Total Mark') }" type="number" :placeholder="$t('candidateProfile.qualificationDetails.plceHoWith')">
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
                  <div class="para">{{$t('candidateProfile.qualificationDetails.lblOutOf')}}</div>
                  <input name="Out Of" class="form-control-alt col-3 uppercase" id="outOf" :min="educationDetails.totalMarksObtained" v-model="educationDetails.outOf" v-validate="'required|numeric'" :class="{'form-error': errors.has('form-1.Out Of'), 'input': true, 'is-danger': errors.has('form-1.Out Of') }" type="number" :placeholder="$t('candidateProfile.qualificationDetails.plceHoOutOf')" >
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
          </div>

          
                  <div class=" row text-center p-3 pt-4">
                    <button type="button" class="btn btn btn-info-alt mr-3" @click="prevTabFunc"> {{$t('button.back')}}</button>
                    <button type="button" class="btn btn btn-orange ml-auto" @click="save"> {{$t('button.next')}}</button>
                  </div>
        </div>
      </form>
          <modal class="lg" v-if="showModal" @close="showModal = false">   
              <h3 slot="header" v-if="currentEduType == 'Diploma' || currentEduType == 'SSC' || currentEduType == 'HSC'">{{currentEduType}} {{$t('candidateProfile.qualificationDetails.lblDocument')}}</h3>
              <h3 slot="header" v-if="currentEduType == 'HSCHallTicket'">{{$t('candidateProfile.qualificationDetails.lblHSCHallTicketDetails')}} {{$t('candidateProfile.qualificationDetails.lblDocument')}}</h3>
              <h3 slot="header" v-if="currentEduType == 'DiplomaHallTicket'">{{$t('candidateProfile.qualificationDetails.lblDiplomaHallTicketDetails')}} {{$t('candidateProfile.qualificationDetails.lblDocument')}}</h3>
          <div slot="body">
           <img :src="marksheetUrl" width="100%"></img>
           </div>
    </modal>
   </div>
</template>
<script>
import myDatepicker from 'vue2-datepicker'
import axios from 'axios'
import moment from 'moment'
import modal from '@/components/common/modal.vue'
export default {
  name: 'QualificationDetails',
  components: {
    'date-picker': myDatepicker, modal
  },
  data () {
    return {
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
      placeholder: {
        date: 'Select Passing Date',
        dateRange: 'Select Date Range'
      },
      start: new Date(1960, 2, 1),
      end: new Date(2001, 8, 1),
      startTime: '',
      disabledDates: {
        to: new Date(2001, 8, 1),
        from: new Date(1960, 2, 1)
        /* daysOfMonth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] */
      },
      educationDetails: {},
      selectedBoard: null,
      boardList: [],
      documentList: [],
      educationStatus: {},
      currentEduType: 'SSC',
      marksheetUrl: '',
      showModal: false
    }
  },
  methods: {
    validateMarks () {
      if (parseInt(this.educationDetails.totalMarksObtained) > parseInt(this.educationDetails.outOf)) {
        return true
      } else {
        return false
      }
    },
    prevTabFunc () {
      var self = this
      if (this.currentEduType === 'SSC') {
        this.$router.push('documentsupload')
      } else {
        this.$validator.validate().then((results) => {
          if (results) {
            this.currentEduType = 'SSC'
            this.clearObject()
          } else {
            this.$toasted.error(self.$t('candidateProfile.qualificationDetails.toastrInvalidData'))
          }
        }).catch(e => {
          this.$toasted.error(self.$t('toastr.toastrSomethingWentWrongs'))
        })
      }
    },
    clearObject (type) {
      // currentEduType = 'SSC',this.currentEduType = type
      this.marksheetUrl = ''
      this.startTime = ''
      this.selectedBoard = null
      this.educationDetails = {}
      if (this.currentEduType === 'SSC' || this.currentEduType === 'HSC' || this.currentEduType === 'Diploma') {
        this.getUserSSCDetails()
      }
      this.getDocumentDetails()
      this.$validator.clean()
    },
    getBoardDetails () {
      var self = this
      axios.get('r/candidateProfile/getBoardDetails')
            .then(function (response) {
              if (response.status === 200) {
                self.boardList = response.data
                self.getUserSSCDetails()
                // self.certificationList.push(self.defaultObj)
              }
            })
            .catch(function () {
              self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'))
            })
    },
    getUserSSCDetails () {
      var self = this
      var profileUser = this.$store.state.candidateProfile.profileUser
      axios.get('r/candidateProfile/get' + this.currentEduType + 'Details/' + profileUser)
            .then(function (response) {
              if (response.status === 200) {
                self.educationDetails = response.data
                for (var i in self.boardList) {
                  if (self.boardList[i].boardName === self.educationDetails.board) {
                    self.selectedBoard = self.boardList[i]
                  }
                }
                if (self.educationDetails.dateOfResult !== undefined && self.educationDetails.dateOfResult !== null && self.educationDetails.dateOfResult !== '') {
                  var dateArray = self.educationDetails.dateOfResult.split('/')
                  var supportDate = dateArray[2].concat('-').concat(dateArray[1]).concat('-').concat(dateArray[0])
                  self.startTime = moment(String(supportDate)).format('YYYY-MM-DD')
                }
              }
            })
            .catch(function () {
             /*  self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
                theme: 'bubble',
                duration: 2000
              }) */
            })
    },
    save () {
      var profileUser = this.$store.state.candidateProfile.profileUser
      var self = this
      if (this.currentEduType === 'SSC' || this.currentEduType === 'HSC' || this.currentEduType === 'Diploma') {
        if (parseInt(this.educationDetails.totalMarksObtained) > parseInt(this.educationDetails.outOf)) {
          this.$toasted.error(this.$t('candidateProfile.qualificationDetails.toastrMarkNotValid'))
          return false
        }
        this.$validator.validate().then((result) => {
          if (result) {
            this.educationDetails.board = this.selectedBoard.boardName
            this.educationDetails.percent = ((parseInt(this.educationDetails.totalMarksObtained) * 100) / parseInt(this.educationDetails.outOf)).toPrecision(4)
            this.educationDetails.seatNumber = this.educationDetails.seatNumber.toUpperCase()
            this.educationDetails.marksheetNo = this.educationDetails.marksheetNo.toUpperCase()
            this.educationDetails.dateOfResult = moment(String(this.startTime)).format('DD/MM/YYYY')
            axios.post('r/candidateProfile/save' + this.currentEduType + 'Details/' + profileUser, this.educationDetails)
                .then(response => {
                  if (response.status === 200) {
                    this.$toasted.success(this.currentEduType + self.$t('toastr.toastrDetailsSaved'))
                    if (this.currentEduType === 'SSC') {
                      if (this.educationStatus.isHSCPassed) {
                        this.currentEduType = 'HSC'
                      } else if (this.educationStatus.isDiplomaPassed) {
                        this.currentEduType = 'Diploma'
                      } else if (this.educationStatus.isHSCAppeared) {
                        this.currentEduType = 'HSCHallTicket'
                      } else if (this.educationStatus.isDiplomaAppeared) {
                        this.currentEduType = 'DiplomaHallTicket'
                      } else {
                        this.$router.push('profileSummary')
                      }
                      this.clearObject()
                      return true
                    } else {
                      this.$router.push('profileSummary')
                    }
                  }
                })
                .catch(e => {
                  console.log(e)
                  return false
                })
          } else {
            this.$toasted.error(self.$t('candidateProfile.qualificationDetails.toastrInvalidData'))
          }
        }).catch(e => {
          this.$toasted.error(self.$t('toastr.toastrSomethingWentWrongs'))
        })
      } else if (this.currentEduType === 'DiplomaHallTicket' || this.currentEduType === 'HSCHallTicket') {
        axios.post('r/candidateProfile/SaveQualificationDetailsStatus/' + profileUser)
        .then(function (response) {
          if (response.status === 200 && response.data) {
            self.$router.push('profileSummary')
          }
        })
        .catch(function () {
          self.$toasted.error(self.$t('toastr.toastrSomethingWentWrongs'))
        })
      }
    },
    getEducationDetails () {
      var self = this
      var profileUser = this.$store.state.candidateProfile.profileUser
      axios.get('r/candidateProfile/getQualificationDetails/' + profileUser)
      .then(function (response) {
        if (response.status === 200) {
          self.educationStatus = response.data
        }
      })
      .catch(function () {
        self.$toasted.error('Error while featch education details')
      })
    },
    getDocumentDetails () {
      var profileUser = this.$store.state.candidateProfile.profileUser
      var self = this
      axios.get('r/ocr/documents/' + profileUser)
         .then(function (response) {
           if (response.status === 200) {
             self.documentList = response.data
             for (var i in self.documentList) {
               if (self.documentList[i].documentKey === self.currentEduType) {
                 self.marksheetUrl = self.documentList[i].marksheetUrl
                 break
               }
             }
           }
         }).catch(function (e) {
           console.error(e)
           self.$toasted.error(self.$('candidateProfile.imageExtracter.toastrCertificationDetailsFeatchError'))
         })
    }
  },
  created: function () {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' })
    } else {
      this.getDocumentDetails()
      this.getEducationDetails()
      this.getBoardDetails()
    }
  }
}
</script>
<style lang='scss'>
  .uppercase{
 text-transform: uppercase;
  }
  .dpics{border-radius:5px; display: block; width:100%; height: 80px; margin-top:10px;}
  .dpics{
    transition: all .2s ease-in;
    cursor: pointer;
  }
  .dpics:hover{
    transform: scale(1.1);
    border: 2px solid #ccc;
  }
  .green-note{
    color:green;
  }
</style>



// WEBPACK FOOTER //
// src/components/registration/qualificationDetails.vue